import React, { memo } from "react";
import { Outlet } from "react-router-dom";
import { setTitle } from "../helpers/MetaTag";

const BlankLayout = ({ metaTitle }) => {
  setTitle(`Plotics Admin | ${metaTitle}`);

  return <Outlet />;
};

export default memo(BlankLayout);
